import React from 'react';
import RegisterForm from './RegisterForm';
import LoginBanner from '../../../assets/images/login-banner-2.gif';

const Register: React.FC = () => {
  return (
    <section className="loginSection">
      <div className="loginWrap">
        <RegisterForm />
        <img
          src={LoginBanner}
          alt=""
          className="LoginBanner"
        />
      </div>
    </section>
  );
};

export default Register;
